export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  rating: number;
  totalChapters: number;
  totalViews: string;
  status: string;
  description: string;
  tags: string[];
  chapters: ComicChapter[];
  featured: boolean;
  latest: boolean;
}

export const categories = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 328 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 256 },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', count: 192 },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', count: 147 },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line', count: 183 },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 215 },
  { name: 'BL', slug: 'bl', icon: 'ri-user-heart-line', count: 164 },
  { name: '剧情', slug: 'drama', icon: 'ri-emotion-line', count: 138 },
  { name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line', count: 97 },
];

export const featuredComics: Comic[] = [
  {
    id: '1',
    slug: 'secretarys-secret',
    title: '秘书的秘密',
    author: '朴智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20elegant%20office%20lady%20in%20soft%20coral%20and%20cream%20tones%2C%20minimalist%20illustration%20style%2C%20clean%20simple%20background%2C%20warm%20atmospheric%20lighting%2C%20webtoon%20aesthetic%2C%20sophisticated%20character%20design%2C%20soft%20color%20palette&width=800&height=1000&seq=manhwa-feat-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    rating: 9.5,
    totalChapters: 86,
    totalViews: '1280万',
    status: '连载中',
    description: '职场精英的秘密恋情，在高压的办公室政治中，她与上司之间不可告人的情感逐渐浮出水面。一段充满张力的办公室罗曼史。',
    tags: ['办公室', '年上', '秘密恋爱', '职场'],
    chapters: [],
    featured: true,
    latest: false,
  },
  {
    id: '2',
    slug: 'demon-king-returns',
    title: '魔王归来',
    author: '金贤秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20dark%20fantasy%20warrior%20with%20magical%20aura%2C%20dramatic%20coral%20and%20gold%20color%20scheme%2C%20clean%20simple%20background%20with%20subtle%20glow%2C%20webtoon%20aesthetic%2C%20powerful%20character%20pose%2C%20epic%20mood&width=800&height=1000&seq=manhwa-feat-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    rating: 9.7,
    totalChapters: 134,
    totalViews: '2560万',
    status: '连载中',
    description: '被封印千年的魔王在现代苏醒，却发现世界早已面目全非。为了找回失去的力量，他必须在人类世界中隐藏身份，一步步重登巅峰。',
    tags: ['异世界', '战斗', '升级', '隐藏身份'],
    chapters: [],
    featured: true,
    latest: false,
  },
  {
    id: '3',
    slug: 'sweet-poison',
    title: '甜蜜的毒药',
    author: '李恩在',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20beautiful%20woman%20with%20mysterious%20expression%2C%20soft%20peach%20and%20coral%20tones%2C%20elegant%20minimalist%20illustration%2C%20clean%20simple%20background%2C%20webtoon%20style%2C%20intricate%20character%20design%2C%20romantic%20atmosphere&width=800&height=1000&seq=manhwa-feat-03&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    rating: 9.3,
    totalChapters: 72,
    totalViews: '980万',
    status: '已完结',
    description: '当爱情变成一种毒药，她是沉沦还是自拔？一场始于欺骗的情感游戏，最终却让两个人都深陷其中无法脱身。',
    tags: ['虐恋', '契约恋爱', '反转', '都市'],
    chapters: [],
    featured: true,
    latest: true,
  },
  {
    id: '4',
    slug: 'shadow-hunter',
    title: '暗影猎手',
    author: '崔志浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20badass%20hunter%20character%20in%20dynamic%20pose%2C%20dark%20atmospheric%20illustration%20with%20coral%20accent%20colors%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20modern%20urban%20fantasy%20vibe&width=800&height=1000&seq=manhwa-feat-04&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    rating: 9.4,
    totalChapters: 108,
    totalViews: '1830万',
    status: '连载中',
    description: '在一个被暗影生物威胁的世界里，觉醒者们挺身而出。他是最强的暗影猎手，却背负着无法言说的过去。',
    tags: ['猎人', '觉醒', '战斗', '异能'],
    chapters: [],
    featured: true,
    latest: false,
  },
  {
    id: '5',
    slug: 'my-boss-is-a-cat',
    title: '我的上司是只猫',
    author: '赵允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20cute%20cat%20character%20in%20office%20setting%2C%20warm%20golden%20and%20cream%20color%20palette%2C%20playful%20minimalist%20illustration%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20lighthearted%20mood&width=800&height=1000&seq=manhwa-feat-05&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    rating: 9.1,
    totalChapters: 56,
    totalViews: '720万',
    status: '连载中',
    description: '新入职的菜鸟发现自己的直属上司竟然是一只会说话的猫？!荒诞又温馨的职场日常就此展开。',
    tags: ['职场', '猫咪', '治愈', '搞笑'],
    chapters: [],
    featured: true,
    latest: true,
  },
  {
    id: '6',
    slug: 'night-flower',
    title: '夜之花',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20art%2C%20mysterious%20woman%20in%20dark%20alley%2C%20noir%20atmosphere%20with%20warm%20coral%20highlight%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20suspenseful%20mood%2C%20elegant%20character%20design&width=800&height=1000&seq=manhwa-feat-06&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    rating: 9.6,
    totalChapters: 94,
    totalViews: '1560万',
    status: '连载中',
    description: '每到夜晚就会出现在犯罪现场的美丽女人，是凶手还是目击者？刑警与她的危险博弈就此展开。',
    tags: ['犯罪', '推理', '反转', '都市'],
    chapters: [],
    featured: true,
    latest: false,
  },
];

export const latestUpdates: Comic[] = [
  {
    id: '7',
    slug: 'first-love-never-dies',
    title: '初恋不死',
    author: '金秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20scene%20art%2C%20young%20couple%20in%20school%20uniform%20under%20cherry%20blossoms%2C%20soft%20peach%20and%20cream%20color%20palette%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20nostalgic%20sweet%20atmosphere&width=800&height=600&seq=manhwa-update-01&orientation=landscape',
    category: '恋爱',
    categorySlug: 'romance',
    rating: 9.2,
    totalChapters: 64,
    totalViews: '890万',
    status: '连载中',
    description: '十年后的同学聚会，曾经暗恋的对象再次出现，这一次她决定不再错过。',
    tags: ['校园', '初恋', '重逢', '纯爱'],
    chapters: [
      { id: 'ch-64', title: '第64话 - 重逢的约定', number: 64, updatedAt: '2026-07-03' },
      { id: 'ch-63', title: '第63话 - 雨中的告白', number: 63, updatedAt: '2026-06-26' },
    ],
    featured: false,
    latest: true,
  },
  {
    id: '8',
    slug: 'revenge-game',
    title: '复仇游戏',
    author: '朴宰范',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20scene%20art%2C%20intense%20corporate%20battle%20scene%2C%20dramatic%20coral%20and%20dark%20tones%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20tense%20atmosphere%2C%20powerful%20composition&width=800&height=600&seq=manhwa-update-02&orientation=landscape',
    category: '剧情',
    categorySlug: 'drama',
    rating: 9.4,
    totalChapters: 78,
    totalViews: '1120万',
    status: '连载中',
    description: '被最信任的伙伴背叛后，他从地狱归来，精心策划了一场完美的复仇。',
    tags: ['复仇', '商战', '黑化', '爽文'],
    chapters: [
      { id: 'ch-78', title: '第78话 - 最后的棋子', number: 78, updatedAt: '2026-07-02' },
      { id: 'ch-77', title: '第77话 - 真相浮现', number: 77, updatedAt: '2026-06-25' },
    ],
    featured: false,
    latest: true,
  },
  {
    id: '9',
    slug: 'cafe-moonlight',
    title: '月光咖啡馆',
    author: '郑多彬',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20scene%20art%2C%20cozy%20cafe%20interior%20at%20night%2C%20warm%20golden%20lighting%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20peaceful%20atmosphere%2C%20charming%20character%20interaction&width=800&height=600&seq=manhwa-update-03&orientation=landscape',
    category: '日常',
    categorySlug: 'slice-of-life',
    rating: 9.0,
    totalChapters: 42,
    totalViews: '510万',
    status: '连载中',
    description: '深夜还在营业的神秘咖啡馆，每位顾客都有自己独特的故事。温暖治愈的都市日常。',
    tags: ['咖啡', '治愈', '都市', '日常'],
    chapters: [
      { id: 'ch-42', title: '第42话 - 最后一杯拿铁', number: 42, updatedAt: '2026-07-03' },
      { id: 'ch-41', title: '第41话 - 陌生人的礼物', number: 41, updatedAt: '2026-06-27' },
    ],
    featured: false,
    latest: true,
  },
];

export const allCategoryComics: Comic[] = [
  {
    id: '10',
    slug: 'cherry-blossom-destiny',
    title: '樱花缘',
    author: '尹智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%20art%2C%20two%20beautiful%20male%20characters%20under%20cherry%20blossoms%2C%20soft%20peach%20and%20cream%20color%20palette%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20romantic%20atmosphere%2C%20elegant%20minimalist%20illustration&width=800&height=1000&seq=manhwa-bl-01&orientation=portrait',
    category: 'BL',
    categorySlug: 'bl',
    rating: 9.4,
    totalChapters: 68,
    totalViews: '1620万',
    status: '连载中',
    description: '樱花树下的邂逅，改变了两个少年的一生。从校园到职场，他们用十年时间证明了这份感情的真实与坚定。',
    tags: ['校园', '成长', '纯爱', '治愈'],
    chapters: [
      { id: 'ch-68', title: '第68话 - 樱花再开时', number: 68, updatedAt: '2026-07-03' },
    ],
    featured: false,
    latest: true,
  },
  {
    id: '11',
    slug: 'blue-ocean-love',
    title: '蔚蓝深海',
    author: '韩智勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20drama%20cover%20art%2C%20two%20male%20characters%20at%20seaside%20sunset%2C%20warm%20coral%20and%20golden%20tones%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20emotional%20atmosphere%2C%20beautiful%20illustration&width=800&height=1000&seq=manhwa-bl-02&orientation=portrait',
    category: 'BL',
    categorySlug: 'bl',
    rating: 9.6,
    totalChapters: 52,
    totalViews: '980万',
    status: '已完结',
    description: '海洋学家与冲浪教练在海边小镇相遇，两个性格迥异的人被命运的红线紧紧系在一起。一段如海浪般起伏的深情故事。',
    tags: ['海风', '慢热', '深情', '成熟'],
    chapters: [],
    featured: false,
    latest: false,
  },
  {
    id: '12',
    slug: 'moonlight-palace',
    title: '月下宫阙',
    author: '柳承佑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20fantasy%20cover%20art%2C%20ancient%20Korean%20palace%20scene%20with%20noble%20characters%2C%20warm%20golden%20and%20cream%20tones%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20elegant%20traditional%20atmosphere%2C%20beautiful%20hanbok%20costumes&width=800&height=1000&seq=manhwa-hist-01&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    rating: 9.5,
    totalChapters: 92,
    totalViews: '1380万',
    status: '连载中',
    description: '朝鲜王朝时代，一位宫女意外获得了穿越时空的能力，在月下的宫阙中展开了一段跨越百年的奇缘。权谋与爱情交织的史诗。',
    tags: ['宫廷', '穿越', '权谋', '古风'],
    chapters: [
      { id: 'ch-92', title: '第92话 - 月圆之夜', number: 92, updatedAt: '2026-07-02' },
    ],
    featured: false,
    latest: true,
  },
  {
    id: '13',
    slug: 'sword-of-destiny',
    title: '天命之剑',
    author: '姜志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20action%20cover%20art%2C%20ancient%20warrior%20with%20sword%20in%20dramatic%20pose%2C%20warm%20golden%20and%20coral%20color%20scheme%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20epic%20atmosphere%2C%20traditional%20Korean%20setting&width=800&height=1000&seq=manhwa-hist-02&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    rating: 9.3,
    totalChapters: 76,
    totalViews: '1070万',
    status: '连载中',
    description: '一柄上古神剑选择了平凡少年为主人，从此他踏上了守护天下的征程。江湖恩怨、门派纷争，一卷波澜壮阔的武侠画卷。',
    tags: ['武侠', '神剑', '江湖', '热血'],
    chapters: [],
    featured: false,
    latest: false,
  },
  {
    id: '14',
    slug: 'gate-of-otherworld',
    title: '异界之门',
    author: '孙旻奎',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20dungeon%20cover%20art%2C%20hunter%20characters%20facing%20magical%20portal%2C%20dramatic%20coral%20and%20dark%20tone%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20intense%20atmosphere%2C%20dynamic%20composition&width=800&height=1000&seq=manhwa-action-02&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    rating: 9.2,
    totalChapters: 116,
    totalViews: '2140万',
    status: '连载中',
    description: '世界各地突然出现连接异次元的"门"，觉醒特殊能力的"猎人"们组建队伍，深入迷宫猎杀怪物，守护人类文明。',
    tags: ['副本', '猎人', '升级', '团队'],
    chapters: [
      { id: 'ch-116', title: '第116话 - 最终之门', number: 116, updatedAt: '2026-07-01' },
    ],
    featured: false,
    latest: true,
  },
  {
    id: '15',
    slug: 'wizard-academy',
    title: '魔法学院',
    author: '刘在石',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20academy%20cover%20art%2C%20magical%20school%20scene%20with%20students%2C%20warm%20golden%20and%20cream%20tones%2C%20clean%20simple%20background%2C%20webtoon%20aesthetic%2C%20mysterious%20atmosphere%2C%20enchanting%20illustration&width=800&height=1000&seq=manhwa-fantasy-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    rating: 9.1,
    totalChapters: 88,
    totalViews: '1760万',
    status: '连载中',
    description: '被认为是"无魔力者"的少年意外进入魔法学院，在歧视与偏见中一步步证明自己，揭开身世之谜的奇幻冒险。',
    tags: ['学院', '魔法', '成长', '逆袭'],
    chapters: [],
    featured: false,
    latest: false,
  },
];

export const faqItems = [
  {
    id: 'faq-1',
    question: '所有漫画都是免费的吗？',
    answer: '是的！我们网站上的所有韩漫都可以免费在线阅读，无需任何付费。我们致力于为广大漫迷提供最优质的免费阅读体验。',
    category: '阅读问题',
  },
  {
    id: 'faq-2',
    question: '什么是"下拉式"阅读？',
    answer: '下拉式阅读是一种针对手机和网页优化的漫画阅读模式，您只需向下滑动页面即可连续阅读，无需翻页。这种方式更符合移动设备的阅读习惯，让阅读体验更加流畅。',
    category: '阅读问题',
  },
  {
    id: 'faq-3',
    question: '漫画更新频率是怎样的？',
    answer: '不同漫画的更新频率有所不同，热门连载作品通常每周更新1-2话。您可以在每部漫画的详情页查看具体的更新计划，也可以关注我们的更新日历。',
    category: '账号问题',
  },
];

export const testimonials = [
  {
    id: 't-1',
    name: '小糖果',
    level: '资深漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20female%20character%20portrait%2C%20cute%20anime%20style%2C%20soft%20peach%20and%20cream%20background%2C%20clean%20simple%20illustration%2C%20webtoon%20aesthetic&width=200&height=200&seq=manhwa-avatar-01&orientation=squarish',
    content: '这个网站简直是我的快乐源泉！漫画资源超级全，更新速度也很快，每天都在等更新。下拉式阅读体验太棒了，躺着也能轻松看！',
  },
  {
    id: 't-2',
    name: '追漫少年',
    level: 'VIP会员',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20male%20character%20portrait%2C%20cool%20anime%20style%2C%20soft%20coral%20and%20cream%20background%2C%20clean%20simple%20illustration%2C%20webtoon%20aesthetic&width=200&height=200&seq=manhwa-avatar-02&orientation=squarish',
    content: '从其他平台过来的，这里的分类做得特别细致，找漫画超方便。推荐功能也很精准，帮我发现了不少宝藏作品！',
  },
  {
    id: 't-3',
    name: '漫画控',
    level: '活跃读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20female%20character%20portrait%2C%20elegant%20anime%20style%2C%20warm%20golden%20and%20cream%20background%2C%20clean%20simple%20illustration%2C%20webtoon%20aesthetic&width=200&height=200&seq=manhwa-avatar-03&orientation=squarish',
    content: '最喜欢这里的画质了，高清无删减，每一话都看得很过瘾。评论区氛围也超好，大家都很友好地讨论剧情。',
  },
];

export const siteInfo = {
  name: '韩漫屋',
  tagline: '免费韩漫在线阅读 - 下拉式漫画全集无删减',
  description: '韩漫屋汇集韩漫大全，提供漫画韩漫网址和下拉式韩国漫画在线阅读服务，方便您快速找到并阅读所需作品。本站所有漫画均为高清无删减版本，支持手机和电脑阅读。',
  keywords: '韩漫,免费韩漫,韩漫网站,韩漫大全,漫画韩漫网址,下拉式,韩国漫画,在线阅读',
  url: 'http://xxxlc.com/',
  email: 'hello@xxxlc.com',
  phone: '400-888-1234',
  address: '北京市朝阳区望京SOHO T1 15层',
};